import {ThemeProvider} from '@primer/react-brand'
import type {FlexSuiteOverviewPage} from '../../../lib/types/contentful'
import {FlexSuiteHero} from '../components/FlexSuiteHero'

export type OverviewTemplateProps = {
  page: FlexSuiteOverviewPage
}

export function OverviewTemplate({page}: OverviewTemplateProps) {
  const {template, settings} = page.fields
  const pageColorMode = settings?.fields.colorMode ?? 'light'
  const {
    heroHeading,
    heroLabel,
    heroDescription,
    heroCtaOne,
    heroCtaTwo,
    heroTertiaryDescription,
    heroVariant,
    heroImage,
    heroCarousel,
    heroIconCards,
  } = template.fields

  const isExpressive = heroVariant === 'Carousel' || heroVariant === 'Stacked' || heroVariant === 'Icon Cards'

  return (
    <ThemeProvider colorMode={pageColorMode}>
      <FlexSuiteHero
        heroHeading={heroHeading}
        heroLabel={heroLabel}
        heroDescription={heroDescription}
        heroCtaOne={heroCtaOne}
        heroCtaTwo={heroCtaTwo}
        heroTertiaryDescription={heroTertiaryDescription}
        heroVariant={heroVariant}
        heroImage={heroImage}
        heroCarousel={heroCarousel}
        heroIconCards={heroIconCards}
        options={{
          variant: isExpressive ? 'gridline-expressive' : 'gridline',
          align: isExpressive ? 'start' : 'center',
          enableAnimation: true,
        }}
      />
    </ThemeProvider>
  )
}
